// ZOD
import * as z from 'zod';
import { FooterZod, FooterType } from '@/components/organisms/Footer/FooterType';

// Strapi
import { footer } from '@/services/strapiPopulate';

// Utils
import { formatZodError } from '@/utils/error';

// Client
import client from '../client';

export const getFooter = async (): Promise<FooterType> => {
  const response = await client.get('/api/footer', {
    params: {
      populate: footer,
    },
  });

  try {
    return await FooterZod.parseAsync(response.data?.data);
  } catch (error) {
    if (error instanceof z.ZodError) {
      throw new Error(`API response do not match Footer structure:\n${formatZodError(error, response.data?.data)}`);
    }
    throw error;
  }
};
